module.exports = __webpack_public_path__ + "img/RADIANT.78844837.png";